import { GameWithDate } from '../types/types';

export const demoData: GameWithDate = {
  date: '2000-01-02',
  game: {
    words: [
      { text: 'north', offset: 0 },
      { text: 'south', offset: 0 },
      { text: 'east', offset: 0 },
      { text: 'west', offset: 1 },
    ],
    pathString: 'northhtuoseawestst',
    startCoordinates: { x: 0, y: 0 },
    theme: 'A Demonstration of Direction',
  },
  _id: 'demo',
};
